import { getCurrentInstance } from 'vue';
import axios from 'axios';

export default class ServiceHealthChecker {
    private http: any;
    private $vistra: any;
    private readonly healthCheckEndpoint: string = 'health';
    private readonly healthyResponse: string = "Healthy";

    constructor(appParametro?: any) {
        let app = getCurrentInstance();
        if(!app)
            app = appParametro

        this.$vistra = app!?.appContext ? app!?.appContext.config.globalProperties.$vistra : app!?.$vistra;
        this.http = app!?.appContext ? app!?.appContext?.config?.globalProperties?.$http : app!?.$http;
    }
    
    public async isServiceReportExternalUp(url?: string): Promise<boolean> {
        try {
            if(!url)
                return false;

            const axiosInstance = axios.create({
                baseURL: url,
            });
            const response = await axiosInstance.get('health');
            return response.data === this.healthyResponse;
        } catch (error) {
            throw new Error(`Ocorreu um erro interno ao tentar verificar o status do serviço ${url}. Por favor, entre em contato com o suporte técnico.`);
        }
    }
    public async isServiceUp(endpoint: string, url?: string): Promise<boolean> {
        try {
            const response = await this.getHealth(endpoint, url);
            return response
        } catch (error) {
            throw new Error(`Ocorreu um erro interno ao tentar verificar o status do serviço ${endpoint}. Por favor, entre em contato com o suporte técnico.`);
        }
    }

    public async isVistraIAUp(urlIA?: string, usuario?: string, senha?: string): Promise<boolean> {
        try {
            const payload = {
                url: urlIA || '',
                user: usuario || '',
                password: senha || ''
            };

            const response = await this.http.post('/Health/VistraIA/', payload);

            return response.data;
        } catch (error) {
            throw new Error(`Erro ao obter relatório de saúde do serviço ${endpoint}`);
        }
    }

    private async getHealth(endpoint: string, url?: string): Promise<any> {
        try {
            const fullEndpoint = url ? `${endpoint}?url=${encodeURIComponent(url)}` : endpoint;
            const response = await this.http.get(fullEndpoint);
            return response.data;
        } catch (error) {
            throw new Error(`Erro ao obter relatório de saúde do serviço ${endpoint}`);
        }
    }
}
